import type { User } from "./types"

export const userKeys = {
	all: ["user"] as const,
	check: (identifier: string) =>
		[...userKeys.all, "check", identifier] as const,
	byId: (intUserId: User["id"]) =>
		[...userKeys.all, "by-id", intUserId] as const,
} as const
